<h1>What is the purpose of a Tech Radar?</h1>

<p>The Itz Tech Radar is a list of technologies, complemented by an assessment result, called ring assignment.</p>
<p>We use three rings with the following semantics:</p>
<ul>
  <li>NOTIONS — Technologies I have already heard about</li>
  <li>PROEFFICIENT — Technologies I am self confident</li>
  <li>INTERESTED — Technologies that I would be interested in. A training would be welcome</li>
</ul>

<div class="row">
  <div class="col-md-12">
    <div class="form-group label-floating">
      <div class="btn-group ">
        <label class="btn btn-raised" [ngClass]="{'active': displaySurvey}" (click)="displaySurvey = true">
          <input type="radio" autocomplete="off"> Let's compose your Tech radar
        </label>
        <label class="btn btn-raised" [ngClass]="{'active': !displaySurvey}" (click)="displaySurvey = false">
          <input type="radio" autocomplete="off"> Display your Tech radar
        </label>
      </div>
    </div>
  </div>
</div>

@if (displaySurvey) {
  <div>
    <div>
      <h3>For each skill below, please select the more relevant level</h3>
      <p><u>None</u>: I don't know about this subject.</p>
      <p><u>Notions</u>: I have already been confronted with this subject or I have some notions.</p>
      <p><u>Proefficient</u>: I know this subject well. I am confronted with it regularly and I am comfortable with it</p>
      <p></p>
      <p>You may also check the option <u>Training</u> in case you would be interested in learning more through trainings</p>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group label-floating">
          <div class="btn-group ">
            @for (skillCategory of skillCategories; track skillCategory) {
              <label
                class="btn btn-raised"
                [ngClass]="{'active': selectedTab === skillCategory.value}"
                (click)="selectedTab = skillCategory.value"
                >
                <input type="radio" autocomplete="off"> {{skillCategory.label}}
              </label>
            }
          </div>
        </div>
      </div>
    </div>
    @if (selectedTab=='LANGUAGES') {
      <skill-survey [skills]="languagesSkills" (onChange)="draftMode = true"></skill-survey>
    }
    @if (selectedTab=='TOOLS') {
      <skill-survey [skills]="toolsSkills" (onChange)="draftMode = true"></skill-survey>
    }
    @if (selectedTab=='PLATFORMS') {
      <skill-survey [skills]="platformsSkills" (onChange)="draftMode = true"></skill-survey>
    }
    @if (selectedTab=='METHODOLOGIES') {
      <skill-survey [skills]="methodologiesSkills" (onChange)="draftMode = true"></skill-survey>
    }
  </div>
}

<div [hidden]="displaySurvey">
  @if (isCoordinator()) {
    <div class="row">
      <div class="col-md-12">
        <div class="form-group label-static">
          <label class="control-label" for="selectedUser">IT'z</label>
          <select id="selectedUser" name="selectedUser" class="form-control" [(ngModel)]="selectedUser" (change)="handleChange($event)">
            @for (user of users; track user) {
              <option [ngValue]="user">{{user.userFirstName}} {{user.userName}}</option>
            }
          </select>
        </div>
      </div>
    </div>
  }

  <div class="col-md-12 radar-container">
    <radar class="radar" [blips]="this.techRadarData"></radar>
  </div>


  @if (isCoordinator()) {
    <div class="row">
      <table class="table table-bordred table-striped">
        <thead>
          <tr>
            <th>Skill</th>
            <th>Type</th>
            <th>Level</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          @for (skill of techRadarStats; track skill) {
            <tr>
              <td>{{skill.skills.label}}</td>
              <td>{{skill.skills.quadrant}}</td>
              <td>{{skill.skills.level}}</td>
              <td>{{skill.count}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
<!-- NOTIFICATION -->
@if (showAlert) {
  <notification [timeout]="10000" [severity]="notifType" [message]="notifMessage"
  (hideNotification)="showAlert = false"></notification>
}

<!-- WARNING FOR DRAFT MODE -->
@if (draftMode) {
  <notification severity="warning" message="You have unsaved changes">
    <button style="background-color:#888787; margin-left: 10px;" (click)="saveSkills()">SAVE</button>
  </notification>
}
